import { ComponentClassNames } from '../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

import { AppLayoutProps } from './AppLayout.types';

export const dynamicHeightClassName = 'appLayout-dynamicHeight';

type GetClassNames = (
  height: AppLayoutProps['height'],
  disableNativePageScroll: boolean
) => ComponentClassNames<'appLayout'>;
export const getClassNames: GetClassNames = memoizeFunction((height, disableNativePageScroll) => {
  const [, dynamicHeightValue] =
    (typeof height === 'string' && /(.+?)(?:dvh|lvh|svh)$/.exec(height)) || ([] as (string | undefined)[]);

  return mergeStyleSets({
    appLayout: {
      ':global(html)': disableNativePageScroll ? { height: '100%', overscrollBehavior: 'none' } : undefined,
      ':global(body)': disableNativePageScroll ? { height: '100%', overflow: 'hidden' } : undefined,
      ...(dynamicHeightValue
        ? {
            height: `${dynamicHeightValue}vh`,
            [`&.${dynamicHeightClassName}`]: { height },
          }
        : { height }),
    },
  });
});
